import { Injectable } from '@angular/core';

export enum Environment {
  Prod = 'prod',
  Staging = 'staging',
  Uat = 'uat',
  Dev = 'dev',
}

@Injectable({ providedIn: 'root' })
export class EnvService {
  private _env: string;
  private _apiUrl: string;
  public isDev = false;
  public isUat = false;

  get env(): string {
    return this._env;
  }

  get apiUrl(): string {
    return this._apiUrl;
  }

  get cpBuyNowUrl(): string {
    return this._apiUrl + '/eng/courses/';
  }

  get cpLoginUrl(): string {
    return this._apiUrl + '/eng/login/';
  }

  get cpLogoutUrl(): string {
    return this._apiUrl + '/index.php?widget=member_login&_spAction=logout&showHTML=0';
  }

  get errorPageUrl(): string {
    return '/pages/error';
  }
  constructor() { }

  init(): Promise<void> {
    return new Promise(resolve => {
      this.setEnvVariables();

      if (this._env === 'dev') {
        this.isDev = true;
      } else if (this._env === 'uat') {
        this.isUat = true;
      }
      resolve();
    });
  }

  private setEnvVariables(): void {
    const hostname = window && window.location && window.location.hostname;
    
    console.log('EnvService: Detecting environment for hostname:', hostname);

    if (/^.*localhost.*/.test(hostname)) {
      this._env = Environment.Dev;
      this._apiUrl = 'http://evolutioncoursemgt.localhost';
      console.log('EnvService: Set to Dev environment, API URL:', this._apiUrl);

    } else if (/^evolutioncoursemgtpwa-uat.pilot.com.hk/.test(hostname) || /^evolutioncoursemgtpwa\.pilottest\.site/.test(hostname)) {
      this._env = Environment.Uat;
      this._apiUrl = 'https://evolutioncoursemgt.pilottest.site';
      console.log('EnvService: Set to UAT environment, API URL:', this._apiUrl);

    } else if (/^app.evolution-u.com/.test(hostname)) {
      this._env = Environment.Prod;
      this._apiUrl = 'https://online.evolution-u.com';
      console.log('EnvService: Set to Prod environment, API URL:', this._apiUrl);

    } else if (/^evolutioncoursemgtpwa.s3-website.ap-east-1.amazonaws.com/.test(hostname)) {
      this._env = Environment.Prod;
      this._apiUrl = 'https://online.evolution-u.com';
      console.log('EnvService: Set to Prod environment (S3), API URL:', this._apiUrl);

    } else {
      console.warn(`EnvService: Cannot find environment for host name ${hostname}`);
      // Fallback: if hostname contains pilottest.site, assume UAT
      if (/pilottest\.site/.test(hostname)) {
        this._env = Environment.Uat;
        this._apiUrl = 'https://evolutioncoursemgt.pilottest.site';
        console.log('EnvService: Using fallback UAT environment, API URL:', this._apiUrl);
      } else {
        console.error('EnvService: No environment matched and no fallback available. API URL will be undefined!');
      }
    }
  }
}
